var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"gl-footer"},[_c('div',{staticClass:"footer-wrap"},[_c('div',{staticClass:"content-wrap footer-block"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.setting && _vm.setting.footerInfo)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }